import { useLoginModal } from '@/hooks/use-login-modal'

const Login = () => {
  const { openLoginModal } = useLoginModal()
  return (
    <div className="mx-3 fc">
      <div
        className="bg-main19 h-30px w-80px fcc cursor-pointer rounded-8 text-14px text-main"
        onClick={openLoginModal}
      >
        登录
      </div>
    </div>
  )
}
export default Login
